<template>
  <div class="base-simple-timer">
    <span v-if="days">{{ days && !tournament > 99 ? 99 : days }}</span>
    <span v-if="days"> д. </span>
    <span v-if="hours">{{ hours }}</span>
    <span v-if="hours">:</span>
    <span v-if="minutes">{{ minutes }}</span>
    <span v-if="isShowSecond && seconds !== null && minutes">:</span>
    <span v-if="isShowSecond && seconds !== null" class="base-simple-timer__seconds">{{ seconds }}</span>
  </div>
</template>

<script>
export default {
  name: 'BaseSimpleTimer',
  props: {
    end: { type: Number, default: 0 },
    tournament: { type: Boolean, default: false },
    isShowSecond: { type: Boolean, default: true },
    endDiff: { type: Number },
  },
  data() {
    return {
      ms: 1000,
      now: null,
      date: null,
      interval: null,
      diff: 0,
    }
  },
  computed: {
    c_end() {
      if (this.endDiff) {
        return new Date().getTime() + this.endDiff
      }
      else {
        return this.end
      }
    },
    //TODO: чи потрібно орізати хвилини коли вони 0, по стайд гайду та стрибає кожну хв коли в секундах 00
    formatTimeUnit() {
      return (value) => (value < 10 ? `0${value}` : value)
    },
    //TODO: чи потрібно орізати хвилини коли вони 0, по стайд гайду
    seconds() {
      const sec = Math.trunc(this.diff) % 60
      return sec >= 0 ? this.formatTimeUnit(sec) : null
    },

    minutes() {
      return this.formatTimeUnit(Math.trunc(this.diff / 60) % 60) || null
    },
    hours() {
      return this.dateFormat(Math.trunc(this.diff / 60 / 60) % 24) || null
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24) || null
    },
  },
  watch: {
    endDiff() {
      clearInterval(this.interval)
      this.initTimer()
    },
  },
  mounted() {
    this.initTimer()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    initTimer() {
      this.now = new Date().getTime()

      if (this.now < this.c_end) {
        this.diff = (this.c_end - this.now) / this.ms

        this.interval = setInterval(() => {
          if (this.diff <= 0) {
            this.$emit('run-out')
            this.diff = 0
            clearInterval(this.interval)
            return
          }

          this.diff -= 1
          this.$emit('onTick', this.diff)
        }, this.ms)
      }
    },
    dateFormat(value) {
      return value < 10 && value !== 0  ? `0${value}` : value
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
